// extracted by mini-css-extract-plugin
export var aiStarIcon = "_c7-4";
export var closeButton = "_c7-6";
export var dismissButton = "_c7-3";
export var editImageWithAiContainer = "_c7-8";
export var imageUploadWrapper = "_c7-7";
export var misspelledWord = "_c7-5";
export var spellCheckContainer = "_c7-2";
export var spin = "_c7-1";
export var spinning = "_c7-0";